import { forwardRef } from 'react';
import StopIcon from '@assets/img/icons/stop.svg?react';
import cn from 'classnames';

import { type DiceGameCardProps } from '@/common/types/dice-game';
import { Picture } from '@/components/ui/Picture/Picture';

import { ActiveBorder } from '../ActiveBorder/ActiveBorder';

import css from './styles.module.scss';

import greyBgPng from '/img/dice-game/grey-card-bg.png';
import greyBgWebp from '/img/dice-game/grey-card-bg.webp';

const GameOverCard = forwardRef<HTMLDivElement, DiceGameCardProps>(
  ({ isActive, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(css.gameOverCard, props.className)}
      >
        <div className="absolute overflow-hidden rounded-xl top-0 left-0 w-full h-full">
          <Picture
            className="w-full h-full"
            img={greyBgPng}
            webp={greyBgWebp}
            alt="light"
          />
        </div>
        <StopIcon className="w-[42.47%] h-[42.47%] relative z-[2]" />
        {isActive && <ActiveBorder variant="grey" />}
      </div>
    );
  },
);

export { GameOverCard };
